import React, { Fragment, useEffect, useState, useMemo, useCallback } from "react";
import { Link } from "react-router-dom";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledTooltip } from "reactstrap";
import moment from 'moment';
import 'moment-timezone';
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Dropzone from "react-dropzone";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import AsyncSelect from 'react-select/async';

// Formik
import * as Yup from "yup";
import { useFormik, Field, FieldArray } from "formik";
import FormData from 'form-data'
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { getEmployee, resetEmployeeState } from "../../../store/employee/action";
import { resetCompanyState, getCompany } from "../../../store/company/action";
import { resetVendorState, getVendor } from "../../../store/vendor/action";
import { resetPaymentMethodState, getPaymentMethod } from "../../../store/paymentMethod/action";
import { resetPaymentTermState, getPaymentTerm, addNewPaymentTerm } from "../../../store/paymentTerm/action";
import { resetShipmentMethodState, getShipmentMethod, addNewShipmentMethod } from "../../../store/shipmentMethod/action";
import { resetShipmentCarrierState, getShipmentCarrier, addNewShipmentCarrier } from "../../../store/shipmentCarrier/action";
import { resetProductVarianState, getProductVarian } from "../../../store/productVarian/action";
import { resetBranchState, getBranch } from "../../../store/branch/action";
import { resetDepartmentState, getDepartment } from "../../../store/department/action";
import { getAccAccount, resetAccAccountState } from "../../../store/accAccount/action";
import { deleteFile } from "../../../store/file/action";
import { resetTransactionTaxState, getTransactionTax } from "../../../store/transactionTax/action";
import { resetSalesState, getSales as onGetSales, addNewSales as onAddNewSale, updateSales as onUpdateSale, deleteSales as onDeleteSales, getSalesLoading } from "../../../store/sales/action";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import logoDark from "../../../assets/images/logo-dark.png";
import logoLight from "../../../assets/images/logo-light.png";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import lottie from 'lottie-web';
import { defineElement } from 'lord-icon-element';
defineElement(lottie.loadAnimation);

const Sale = () => {
  const [modal, setModal] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [modalHistory, setModalHistory] = useState(false);
  const [modalApprove, setModalApprove] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [customActiveTab, setCustomActiveTab] = useState("1");
  const [userRole, setRoles] = useState(null);
  const [userType, setUserType] = useState("user");

  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) {
      setCustomActiveTab(tab);
    }
  };
  const dispatch = useDispatch();

  const { sales, saleAdded, isSaleCreated, isSaleSuccess, loading, error, employees, employeeLoading, paymentMethods, paymentMethodLoading,
    paymentTerms, paymentTermLoading, companies, companyLoading, vendors, vendorLoading, shipmentMethods, shipmentMethodLoading, shipmentCarriers, shipmentCarrierLoading,
    branches, branchLoading, accAccounts, accAccountLoading, transactionTaxs, transactionTaxLoading, productVarians, productVarianLoading, departments, departmentLoading } = useSelector((state) => ({
      saleAdded: state.Sales.saleAdded,
      sales: state.Sales.sales,
      isSaleCreated: state.Sales.isSaleCreated,
      isSaleSuccess: state.Sales.isSaleSuccess,
      loading: state.Sales.loading,
      companies: state.Company.companies,
      companyLoading: state.Company.loading,
      paymentMethods: state.PaymentMethod.paymentMethods,
      paymentMethodLoading: state.PaymentMethod.loading,
      employees: state.Employee.employees,
      employeeLoading: state.Employee.loading,
      paymentTerms: state.PaymentTerm.paymentTerms,
      paymentTermLoading: state.PaymentTerm.loading,
      shipmentMethods: state.ShipmentMethod.shipmentMethods,
      shipmentMethodLoading: state.ShipmentMethod.loading,
      vendors: state.Vendor.vendors,
      vendorLoading: state.Vendor.loading,
      branches: state.Branch.branches,
      branchLoading: state.Branch.loading,
      accAccounts: state.AccAccount.accAccounts,
      accAccountLoading: state.AccAccount.loading,
      shipmentCarriers: state.ShipmentCarrier.shipmentCarriers,
      shipmentCarrierLoading: state.ShipmentCarrier.loading,
      transactionTaxs: state.TransactionTax.transactionTaxs,
      transactionTaxLoading: state.TransactionTax.loading,
      productVarians: state.ProductVarian.productVarians,
      productVarianLoading: state.ProductVarian.loading,
      departments: state.Department.departments,
      departmentLoading: state.Department.loading,
      error: state.Sales.error,
    }));

  const [saleList, setSaleList] = useState([]);
  const [sale, setSale] = useState([]);
  const [info, setInfo] = useState([]);
  const [saleType, setSaleType] = useState("");
  const [employeeList, setEmployeeList] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusSale, setStatusSale] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [paymentMethodList, setPaymentMethodList] = useState([]);
  const [paymentTermList, setPaymentTermList] = useState([]);
  const [accountingList, setAccountingList] = useState([]);
  const [taxList, setTaxList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [shipmentMethodList, setShipmentMethodList] = useState([]);
  const [shipmentCarrierList, setShipmentCarrierList] = useState([]);
  const [filterDate, setFilterDate] = useState();
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [originalFiles, setOriginalFiles] = useState([]);
  const [productList, setProductList] = useState([]);
  const [assetList, setAssetList] = useState([]);
  const [saleDetailItem, setSaleDetailItem] = useState([]);

  const [isSearch, setIsSearch] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const statusSaleData = [
    {
      options: [
        { label: "Pending", value: "1" },
        { label: "Confirmed", value: "2" },
        { label: "Paid", value: "3" },
        { label: "Shipped", value: "4" },
        { label: "Completed", value: "5" },
        { label: "Canceled", value: "6" },
        { label: "Returned", value: "7" },
        { label: "Refunded", value: "8" },
      ],
    }];

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      let filteredSales = sales;
      if (type !== "all") {
        filteredSales = sales.filter((sale) => sale.sales_status.name === type);
      }
      setSaleList(filteredSales);
    }
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    setSaleList(sales);
  }, [sales]);

  useEffect(() => {
    if (!isSearch) {
      dispatch(resetSalesState());
      dispatch(onGetSales({ "type": "purchasing" }));
      setIsSearch(true);
      setIsEdit(false);
      const obj = JSON.parse(localStorage.getItem("authUser"));
      if (
        obj.data &&
        obj?.data?.user?.user_position &&
        obj?.data?.user?.user_position?.position_role
      ) {
        setRoles(obj?.data?.user?.user_position?.position_role.method);
      }
      if (obj?.data)
        setUserType(obj?.data?.userType);
    }
  }, [dispatch, sales, isSearch]);

  useEffect(() => {
    setSale(saleAdded);
  }, [saleAdded]);

  useEffect(() => {
    if (!isEmpty(saleAdded)) {
      setSale(saleAdded);
    }
  }, [saleAdded]);

  useEffect(() => {
    if (!isEmpty(sales)) {
      setSaleList(sales);
      setInfo(sales[sales.length - 1]);
    }
  }, [sales]);

  const handleValidDate = date => {
    return moment(date, "YYYY/MM/DD").format("MMM D, YYYY");
  };

  useEffect(() => {
    if (companies && !companies.length) {
      dispatch(resetCompanyState());
      dispatch(getCompany());
    }
  }, [dispatch, companies]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      })
      var option = { options: opt }
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  const promiseProductOptions = (e) => {
    if (!productVarianLoading) {
      dispatch(resetProductVarianState());
      setProductList([]);
      if (e.length > 1) {
        dispatch(getProductVarian({ "type": "referral", "title": e }));
      }
      return new Promise((resolve, reject) => {
        while (productVarianLoading);
        resolve(productList);
      });
    }
  }

  useEffect(() => {
    if (!isEmpty(productVarians)) {
      var productVarianData = [];
      var opt = [];
      productVarians.forEach((item, key) => {
        const varian_name = item.pvar_product.product_name;
        const id = item.id;
        const barcode = item.barcode;
        const sku = item.sku;
        const price = item.price;
        const brandId = item.brandId;
        const productId = item.productId;
        let option_name = "";
        item.pvar_options && item.pvar_options.forEach((i, k) => {
          option_name += i.detail_name + "/"
        })

        var obj = { label: varian_name + " " + option_name.slice(0, -1) + " - " + barcode, name: varian_name + " " + option_name.slice(0, -1), barcode: barcode, sku: sku, value: id, price: price, brandId: brandId, productId: productId };
        opt.push(obj);
      })
      var option = { options: opt }
      productVarianData.push(option);
      setProductList(productVarianData);
    }
  }, [productVarians]);

  useEffect(() => {
    if (paymentTerms && !paymentTerms.length && !isSearch) {
      dispatch(getPaymentTerm());
    }
  }, [dispatch, paymentTerms, isSearch]);

  useEffect(() => {
    if (!isEmpty(paymentTerms)) {
      var data = [];
      var opt = [];
      paymentTerms.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      })
      var option = { options: opt }
      data.push(option);
      setPaymentTermList(data);
    }
  }, [paymentTerms]);

  useEffect(() => {
    if (transactionTaxs && !transactionTaxs.length && !isSearch) {
      dispatch(getTransactionTax());
    }
  }, [dispatch, transactionTaxs, isSearch]);

  useEffect(() => {
    if (!isEmpty(transactionTaxs)) {
      var data = [];
      var opt = [];
      transactionTaxs.forEach((item, key) => {
        const tax_name = item.tax_name;
        const id = item.id;
        const amount = item.amount;
        var obj = { label: tax_name, value: id, amount: amount };
        opt.push(obj);
      })
      var option = { options: opt }
      data.push(option);
      setTaxList(data);
    }
  }, [transactionTaxs]);

  useEffect(() => {
    if (shipmentCarriers && !shipmentCarriers.length && !isSearch) {
      dispatch(getShipmentCarrier());
    }
  }, [dispatch, shipmentCarriers, isSearch]);

  useEffect(() => {
    if (!isEmpty(shipmentCarriers)) {
      var data = [];
      var opt = [];
      shipmentCarriers.forEach((item, key) => {
        const carrier_name = item.carrier_name;
        const id = item.id;
        var obj = { label: carrier_name, value: id };
        opt.push(obj);
      })
      var option = { options: opt }
      data.push(option);
      setShipmentCarrierList(data);
    }
  }, [shipmentCarriers]);

  useEffect(() => {
    if (shipmentMethods && !shipmentMethods.length && !isSearch) {
      dispatch(getShipmentMethod());
    }
  }, [dispatch, shipmentMethods, isSearch]);

  useEffect(() => {
    if (!isEmpty(shipmentMethods)) {
      var data = [];
      var opt = [];
      shipmentMethods.forEach((item, key) => {
        const method_name = item.method_name;
        const id = item.id;
        var obj = { label: method_name, value: id };
        opt.push(obj);
      })
      var option = { options: opt }
      data.push(option);
      setShipmentMethodList(data);
    }
  }, [shipmentMethods]);

  useEffect(() => {
    if (paymentMethods && !paymentMethods.length && !isSearch) {
      dispatch(resetPaymentMethodState());
      dispatch(getPaymentMethod());
    }
  }, [dispatch, paymentMethods, isSearch]);

  useEffect(() => {
    if (!isEmpty(paymentMethods)) {
      var data = [];
      var opt = [];
      paymentMethods.forEach((item, key) => {
        const method_name = item.method_name;
        const id = item.id;
        var obj = { label: method_name, value: id };
        opt.push(obj);
      })
      var option = { options: opt }
      data.push(option);
      setPaymentMethodList(data);
    }
    else {
      setPaymentMethodList([]);
    }
  }, [paymentMethods]);

  useEffect(() => {
    if (employees && !employees.length && !isSearch) {
      dispatch(resetEmployeeState());
      dispatch(getEmployee({ type: "referral", status: 2 }));
    }
  }, [employees, isSearch, dispatch]);

  useEffect(() => {
    if (!isEmpty(employees)) {
      var data = [];
      var opt = [];
      employees.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        const taskListId = item.taskListId;
        const positionId = item.positionId
        const position_name = item.employee_position && item.employee_position.name ? item.employee_position.name : "Not set";
        var obj = { label: name + " - " + position_name, value: id, taskListId: taskListId, positionId: positionId };
        opt.push(obj);
      })
      var option = { options: opt }
      data.push(option);
      setEmployeeList(data);
    }
  }, [employees]);

  useEffect(() => {
    if (branches && !branches.length && !isSearch) {
      dispatch(resetBranchState());
      dispatch(getBranch({ status: 2, warehouse: "true" }));
    }
  }, [branches, isSearch, dispatch]);

  useEffect(() => {
    if (!isEmpty(branches)) {
      var branchData = [];
      var opt = [];
      (branches || []).forEach((item, key) => {
        const branch_name = item.branch_name;
        const id = item.id;
        var obj = { label: branch_name, value: id };
        opt.push(obj);
      })
      var option = { options: opt }
      branchData.push(option);
      setBranchList(branchData);
    }
  }, [branches]);

  function handleCompanyClick(companyId) {
    dispatch(resetAccAccountState());
    dispatch(getAccAccount({ companyId: companyId, status: 2 }));
    dispatch(resetDepartmentState());
    dispatch(getDepartment({ companyId: companyId, status: 2 }));
    return false;
  }

  useEffect(() => {
    if (!isEmpty(departments)) {
      var departmentData = [];
      var opt = [];
      departments.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      })
      var option = { options: opt }
      departmentData.push(option);
      setDepartmentList(departmentData);
    }
  }, [departments]);

  useEffect(() => {
    if (vendors && !vendors.length && !isSearch) {
      dispatch(resetVendorState());
      dispatch(getVendor({ status: 2 }));
    }
  }, [vendors, isSearch, dispatch]);

  useEffect(() => {
    if (!isEmpty(vendors)) {
      var vendorData = [];
      var opt = [];
      vendors.forEach((item, key) => {
        const vendor_name = item.vendor_name;
        const id = item.id;
        var obj = { label: vendor_name, value: id };
        opt.push(obj);
      })
      var option = { options: opt }
      vendorData.push(option);
      setVendorList(vendorData);
    }
  }, [vendors]);

  useEffect(() => {
    if (!isEmpty(accAccounts)) {
      var data = [];
      var opt = [];
      accAccounts.forEach((item, key) => {
        const account_name = item.name;
        const account_code = item.code;
        const id = item.id;
        var obj = { label: account_code + " " + account_name, value: id };
        opt.push(obj);
      })
      var option = { options: opt }
      data.push(option);
      setAccountingList(data);
    }
  }, [accAccounts]);

  const onClickDelete = (sale) => {
    setSale(sale);
    setDeleteModal(true);
  };

  const handleDeleteSale = () => {
    if (sale) {
      dispatch(onDeleteSales(sale));
      setDeleteModal(false);
    }
  };

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setSale(null);
      setSelectedFiles([]);
      setOriginalFiles([]);
      setSaleDetailItem([]);
    } else {
      setModal(true);
    }
  }, [modal]);

  const toggleDetail = useCallback(() => {
    if (modalDetail) {
      setModalDetail(false);
      setSale(null);
      setSaleDetailItem([]);
      setSelectedFiles([]);
      setOriginalFiles([]);
    } else {
      setModalDetail(true);
    }
  }, [modalDetail]);

  const toggleApprove = useCallback(() => {
    if (modalApprove) {
      setModalApprove(false);
    } else {
      setModalApprove(true);
    }
  }, [modalApprove]);

  const toggleHistory = useCallback(() => {
    if (modalHistory) {
      setModalHistory(false);
    } else {
      setModalHistory(true);
    }
  }, [modalHistory]);

  const handleInvoiceClick = (arg) => {
    const sale = arg;
    let saleDetail = [];

    setSubTotal(parseInt(sale.sub_amount || 0));
    setShip(parseInt(sale.shipment_amount || 0));
    setTax(parseInt(sale.sales_tax.amount || 0));
    setDis(parseInt(sale.disc_amount || 0));

    setSaleType(sale.sales_type);
    if (sale.sales_detail) {
      sale.sales_detail.forEach(element => {
        saleDetail.push({
          detailId: element.id,
          itemId: element.productVarianId,
          item: { label: element.item_name, value: element.productVarianId, name: element.item_name, sku: element.sku, barcode: element.barcode, price: element.amount, brandId: element.brandId, productId: element.productId },
          amount: Math.round(element.amount, 0),
          quantity: Math.round(element.quantity, 0),
          total: Math.round(element.amount_total, 0),
          name: element.item_name,
          sku: element.sku,
          barcode: element.barcode,
          brandId: element.brandId,
          accepted: element.accepted ? Math.round(element.accepted, 0) : 0,
          rejected: element.rejected ? Math.round(element.rejected, 0) : 0,
        });
      });
      setSaleDetailItem(saleDetail);
    }
    let files = [];
    for (const f of sale.sales_file) {
      files.push({ filename: f.filename, originalname: f.originalname })
    }
    setOriginalFiles(files);

  }

  const handleSaleClick = useCallback((arg) => {
    const sale = arg;
    let saleDetail = [];

    setSubTotal(parseInt(sale.sub_amount || 0));
    setShip(parseInt(sale.shipment_amount || 0));
    setTax(parseInt(sale.sales_tax ? sale.sales_tax.amount : 0));
    setDis(parseInt(sale.disc_amount || 0));

    setSaleType(sale.sales_type);
    if (sale.sales_detail) {
      sale.sales_detail.forEach(element => {
        saleDetail.push({
          detailId: element.id,
          itemId: element.productVarianId,
          item: { label: element.item_name, value: element.productVarianId, name: element.item_name, sku: element.sku, barcode: element.barcode, price: element.amount, brandId: element.brandId, productId: element.productId },
          amount: Math.round(element.amount, 0),
          quantity: Math.round(element.quantity, 0),
          total: Math.round(element.amount_total, 0),
          name: element.item_name,
          sku: element.sku,
          barcode: element.barcode,
          brandId: element.brandId,
          accepted: element.accepted ? Math.round(element.accepted, 0) : 0,
          rejected: element.rejected ? Math.round(element.rejected, 0) : 0,
        });
      });
      setSaleDetailItem(saleDetail);
    }
    let files = [];
    for (const f of sale.sales_file) {
      files.push({ filename: f.filename, originalname: f.originalname })
    }
    setOriginalFiles(files);

    setSale({
      id: sale.id,
      transactionat: sale.transactionat,
      dueat: sale.dueat,
      discount: sale.disc_amount || 0,
      description: sale.description,
      shipment_amount: sale.shipment_amount,
      shipment_carrier: sale.sales_shipment_carrier && { label: sale.sales_shipment_carrier.carrier_name, value: sale.sales_shipment_carrier.id },
      shipment_method: sale.sales_shipment_method && { label: sale.sales_shipment_method.method_name, value: sale.sales_shipment_method.id },
      transaction_no: sale.transaction_no,
      sales_type: sale.sales_type && { label: sale.sales_type, value: sale.sales_type },
      account: sale.sales_acc_account && { label: sale.sales_acc_account.account_name, value: sale.sales_acc_account.id },
      department: sale.sales_department && { label: sale.sales_department.name, value: sale.sales_department.id },
      transaction_reff: sale.transaction_reff,
      tax: sale.sales_tax && { label: sale.sales_tax.tax_name, value: sale.sales_tax.id, amount: sale.sales_tax.amount },
      branch: sale.sales_branch && { label: sale.sales_branch.branch_name, value: sale.sales_branch.id },
      company: sale.sales_company && sale.sales_company.name && { label: sale.sales_company.name, value: sale.sales_company.id },
      vendor: sale.sales_vendor && sale.sales_vendor.vendor_name && { label: sale.sales_vendor.vendor_name, value: sale.sales_vendor.id },
      payment_method: sale.sales_pm && { label: sale.sales_pm.method_name, value: sale.sales_pm.id },
      payment_term: sale.sales_payment_term && { label: sale.sales_payment_term.name, value: sale.sales_payment_term.id },
      status: sale.sales_status && { label: sale.sales_status.name, value: sale.sales_status.id },
    });

    setIsEdit(true);
    toggle();
  }, [toggle]);

  function currencyFormat(num) {
    return 'Rp ' + parseFloat(num).toLocaleString(['ban', 'id'])
  }

  const columns = useMemo(
    () => [
      {
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()} />,
        Cell: (cellProps) => {
          return <input type="checkbox" className="dataCheckbox form-check-input" value={cellProps.row.original.id} />;
        },
        id: '#',
      },
      {
        Header: "Invoice No",
        accessor: "transaction_no",
        filterable: true,
        Cell: (cellProps) => (
          <Link to="#" className="fw-semibold" onClick={() => {
            let data = cellProps.row.original;
            handleInvoiceClick(data);
            setInfo(data);
            setModalDetail(true);
          }}>{cellProps.row.original.transaction_no}</Link>),
      },
      {
        Header: "Type",
        accessor: "sales_type",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "Asset":
              return <Link to="#" className="badge text-uppercase badge-soft-info" onClick={() => {
                const data = cell.row.original;
                handleInvoiceClick(data);
                setInfo(data);
                setModalDetail(true);
              }}>{cell.value}</Link>;
            default:
              return <Link to="#" className="badge text-uppercase badge-soft-success" onClick={() => {
                const data = cell.row.original;
                handleInvoiceClick(data);
                setInfo(data);
                setModalDetail(true);
              }}>{cell.value}</Link>;
          }
        }
      },
      {
        Header: "Invoice Ref",
        accessor: "transaction_reff",
        filterable: true,
      },
      {
        Header: "Date",
        accessor: "transactionat",
        filterable: false,
        Cell: (data) => { return handleValidDate(data.row.original.transactionat) }
      },
      {
        Header: "Due Date",
        accessor: "dueat",
        filterable: false,
        Cell: (data) => { return handleValidDate(data.row.original.dueat) }
      },
      {
        Header: "Total",
        accessor: "total_amount",
        filterable: true,
        Cell: (data) => { return (<span>{currencyFormat(data.row.original.total_amount)}</span>) },
      },
      {
        Header: "Quantity",
        accessor: "sub_amount",
        filterable: true,
        Cell: (data) => {
          let qty = 0;
          data.row.original.sales_detail.forEach(element => {
            qty += parseInt(element.quantity);
          });
          return (<span>{Math.round(qty, 0)}</span>)
        },
      },
      {
        Header: "Cost Center",
        accessor: "sales_department.name",
        filterable: true,
      },
      {
        Header: 'Status',
        accessor: "sales_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "DRAFT":
              return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
            case "Pending":
              return <span className="badge text-uppercase badge-soft-secondary">{cell.value}</span>;
            case "CONFIRMED":
              return <span className="badge text-uppercase badge-soft-info">{cell.value}</span>;
            case "PROCESSED":
              return <span className="badge text-uppercase badge-soft-primary">{cell.value}</span>;
            case "COMPLETED":
              return <span className="badge text-uppercase badge-soft-success">{cell.value}</span>;
            default:
              return <span className="badge text-uppercase badge-soft-danger">{cell.value}</span>;
          }
        }
      },
      {
        Header: " ",
        filterable: false,
        Cell: (cellProps) => {
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <Link to="#" className="btn-icon btn btn-sm btn-light" onClick={() => {
                let data = cellProps.row.original;
                handleInvoiceClick(data);
                setInfo(data);
                setModalDetail(true);
              }}><i className="ri-eye-line fs-15"></i>
              </Link>
              <Link to="#" className="btn-icon btn btn-sm btn-light" onClick={() => {
                let data = cellProps.row.original;
                setInfo(data);
                toggleHistory();
              }}><i className=" ri-history-line fs-15"></i>
              </Link>
              {cellProps.row.original.statusId < 4 && (
                <>
                  <Link to="#" className={
                    userType === "admin"
                      ? "btn-icon btn btn-sm btn-light edit-item-btn"
                      : userRole && userRole.split(",").indexOf("updatePos") !== -1
                        ? "btn-icon btn btn-sm btn-light edit-item-btn"
                        : "btn-icon btn btn-sm btn-light edit-item-btn d-none"
                  }
                    onClick={() => {
                      let data = cellProps.row.original;
                      handleSaleClick(data);
                    }}><i className="ri-edit-2-line fs-15"></i>
                  </Link>
                  <Link to="#" className={
                    userType === "admin"
                      ? "btn-icon btn btn-sm btn-soft-danger remove-item-btn"
                      : userRole && userRole.split(",").indexOf("deletePos") !== -1
                        ? "btn-icon btn btn-sm btn-soft-danger remove-item-btn"
                        : "btn-icon btn btn-sm btn-soft-danger remove-item-btn d-none"
                  }
                    onClick={() => {
                      let data = cellProps.row.original;
                      onClickDelete(data);
                    }}><i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Link>
                </>
              )}
              {cellProps.row.original.statusId === 2 && (
                <button className={
                  userType === "admin"
                    ? "btn-label btn btn-sm btn-soft-success fs-12 me-0"
                    : userRole && userRole.split(",").indexOf("approvePos") !== -1
                      ? "btn-label btn btn-sm btn-soft-success fs-12 me-0"
                      : "btn-label btn btn-sm btn-soft-success fs-12 me-0 d-none"
                }
                  onClick={() => {
                    let data = cellProps.row.original;
                    data.statusSaleId = 3;
                    setSale(data);
                    toggleApprove();
                  }}> <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i> Confirmed</button>
              )}
              {cellProps.row.original.statusId === 3 && (
                <button className={
                  userType === "admin"
                    ? "btn-label btn btn-sm btn-soft-success fs-12 me-0"
                    : userRole && userRole.split(",").indexOf("approvePos") !== -1
                      ? "btn-label btn btn-sm btn-soft-success fs-12 me-0"
                      : "btn-label btn btn-sm btn-soft-success fs-12 me-0 d-none"
                }
                  onClick={() => {
                    let data = cellProps.row.original;
                    data.statusSaleId = 4
                    setSale(data);
                    toggleApprove();
                  }}> <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i> Processed</button>
              )}
            </div>
          );
        },
      },
    ], [handleSaleClick, toggleApprove, toggleHistory, userRole, userType]);

  const { getTableProps, rows, getTableBodyProps, headerGroups, page, prepareRow, canPreviousPage, canNextPage, pageOptions, gotoPage, nextPage, previousPage, setPageSize, preGlobalFilteredRows, setGlobalFilter, state: { pageIndex, pageSize } } = useTable(
    {
      columns: columns,
      data: saleList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0, pageSize: 10, selectedRowIds: 0,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const countSearch = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState("");
  const onChange = useAsyncDebounce((value) => { setGlobalFilter(value || undefined); }, 600);

  const [subTotal, setSubTotal] = useState(0);
  const [ship, setShip] = useState(0);
  const [tax, setTax] = useState(0);
  const [dis, setDis] = useState(0);

  function handleFilter() {
    let startat = '';
    let endat = '';
    let datearr = filterDate.split(' to ');
    if (datearr[1]) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    var status = statusSale.value ? statusSale.value : '';
    const param = {
      "title": searchValue,
      "startat": startat,
      "endat": endat,
      "status": status,
      "type": "purchasing"
    }
    dispatch(onGetSales(param));
  }

  const validationApprove = useFormik({
    enableReinitialize: true,
    initialValues: {
      approval_note: "",
    },
    onSubmit: (values) => {
      if (sale) {
        sale.setApprove = true;
        sale.approval_note = values.approval_note;
        dispatch(onUpdateSale(sale));
      }
      validationApprove.resetForm();
      toggleApprove();
    },
  });

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (sale && sale.id) || 0,
      dueat: (sale && sale.dueat) || '',
      transactionat: (sale && sale.transactionat) || '',
      description: (sale && sale.description) || '',
      transaction_no: (sale && sale.transaction_no) || '',
      transaction_reff: (sale && sale.transaction_reff) || '',
      branch: (sale && sale.branch),
      vendor: (sale && sale.vendor),
      company: (sale && sale.company),
      department: (sale && sale.department),
      payment_method: (sale && sale.payment_method),
      payment_term: (sale && sale.payment_term),
      shipment_carrier: (sale && sale.shipment_carrier),
      shipment_method: (sale && sale.shipment_method),
      shipment_amount: (sale && sale.shipment_amount) || 0,
      account: (sale && sale.account),
      status: (sale && sale.status),
      discount: (sale && sale.discount) || 0,
      tax: (sale && sale.tax),
      tax_amount: (sale && sale.tax_amount) || 0,
      sales_type: (sale && sale.sales_type),
    },
    validationSchema: Yup.object({
      company: Yup.object().required("Please enter company").nullable(true),
      sales_type: Yup.object().required("Please enter sale type").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getSalesLoading());
      if (isEdit) {
        let formData = new FormData();
        if (values.files && values.files.length) {
          for (let i = 0; i < values.files.length; i++) {
            formData.append("files", values.files[i]);
          }
        }
        formData.append('id', values.id);
        formData.append('statusSaleId', values.status.value);
        formData.append('sales_type', values.sales_type && values.sales_type.value);
        formData.append('transaction_no', values.transaction_no);
        formData.append('transaction_reff', values.transaction_reff);
        formData.append('transactionat', values.transactionat);
        formData.append('dueat', values.dueat);
        formData.append('description', values.description);
        formData.append('companyId', values.company && values.company.value);
        formData.append('departmentId', values.department && values.department.value);
        formData.append('branchId', values.branch && values.branch.value);
        formData.append('vendorId', values.vendor && values.vendor.value);
        formData.append('shipmentCarrierId', values.shipment_carrier && values.shipment_carrier.value);
        formData.append('shipmentMethodId', values.shipment_method && values.shipment_method.value);
        formData.append('shipment_amount', values.shipment_amount);
        formData.append('paymentMethodId', values.payment_method && values.payment_method.value);
        formData.append('paymentTermId', values.payment_term && values.payment_term.value);
        formData.append('taxId', values.tax && values.tax.value);
        formData.append('accId', values.account && values.account.value);
        formData.append('disc_amount', values.discount);
        formData.append('tax_amount', (tax / 100) * (subTotal + ship - dis));
        formData.append('total_amount', (subTotal + (tax / 100) * (subTotal + ship - dis) + ship) - dis);
        formData.append('sub_amount', subTotal);
        if (saleDetailItem && saleDetailItem.length) {
          formData.append("sales_detail", JSON.stringify(saleDetailItem));
        }
        dispatch(onUpdateSale(formData));
      } else {
        let formData = new FormData();
        if (values.files && values.files.length) {
          for (let i = 0; i < values.files.length; i++) {
            formData.append("files", values.files[i]);
          }
        }
        formData.append('statusSaleId', 1);
        formData.append('sales_type', values.sales_type && values.sales_type.value);
        formData.append('transaction_no', values.transaction_no);
        formData.append('transaction_reff', values.transaction_reff);
        formData.append('transactionat', values.transactionat);
        formData.append('dueat', values.dueat);
        formData.append('description', values.description);
        formData.append('companyId', values.company && values.company.value);
        formData.append('departmentId', values.department && values.department.value);
        formData.append('branchId', values.branch && values.branch.value);
        formData.append('vendorId', values.vendor && values.vendor.value);
        formData.append('shipmentCarrierId', values.shipment_carrier && values.shipment_carrier.value);
        formData.append('shipmentMethodId', values.shipment_method && values.shipment_method.value);
        formData.append('shipment_amount', values.shipment_amount);
        formData.append('paymentMethodId', values.payment_method && values.payment_method.value);
        formData.append('paymentTermId', values.payment_term && values.payment_term.value);
        formData.append('taxId', values.tax && values.tax.value);
        formData.append('accId', values.account && values.account.value);
        formData.append('disc_amount', values.discount);
        formData.append('tax_amount', (tax / 100) * (subTotal + ship - dis));
        formData.append('total_amount', (subTotal + (tax / 100) * (subTotal + ship - dis) + ship) - dis);
        formData.append('sub_amount', subTotal);
        if (saleDetailItem && saleDetailItem.length) {
          formData.append("sales_detail", JSON.stringify(saleDetailItem));
        }
        dispatch(onAddNewSale(formData));
      }
      validation.resetForm();
      toggle();
    },
  });

  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".dataCheckbox");
    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteSales(element.value));
    });
    checkall.checked = false;
  };

  function handleTotalSale() {
    let sub_total = 0;
    for (const item of saleDetailItem) {
      sub_total += parseInt(item.quantity * item.amount);
    }
    setSubTotal(sub_total);
  }

  function handleSaleDetailAdd() {
    let fc = [];
    if (saleDetailItem && saleDetailItem.length) {
      saleDetailItem.forEach(element => {
        fc.push(element);
      });
    }
    fc.push({
      detailId: null,
      itemId: null,
      item: {},
      amount: 0,
      quantity: 0,
      total: 0,
      sku: null,
      barcode: null,
      brandId: null,
    });
    setSaleDetailItem(fc);
  }

  const onClickDeleteDetailItem = (detail) => {
    const object = saleDetailItem.findIndex((obj) => obj.detailId === detail.detailId);
    if (object > -1) {
      saleDetailItem.splice(object, 1);
    }
  };

  function handleAcceptedFiles(files) {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size)
      })
    );
    setSelectedFiles(files);
    validation.setFieldValue("files", files);
  }

  function handleDeleteFiles(filesId) {
    const object = originalFiles.findIndex((obj) => obj.id === filesId);
    if (object > -1) {
      dispatch(deleteFile({ id: filesId }));
      originalFiles.splice(object, 1);
    }
  }

  function handleDeleteUploadedFiles(filesId) {
    const object = selectedFiles.findIndex((obj, idx) => idx === filesId);
    if (object > -1) selectedFiles.splice(object, 1);
  }

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  function printInvoice(ele) {
    var domClone = ele.cloneNode(true);
    var printSection = document.getElementById("printSection");
    if (!printSection) {
      printSection = document.createElement("div");
      printSection.id = "printSection";
      document.body.appendChild(printSection);
    }
    printSection.innerHTML = "";
    printSection.appendChild(domClone);
    window.print();
    return false
  }

  document.title = "Sales | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={saleList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteSale} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal show={deleteModalMulti}
        onDeleteClick={() => { deleteMultiple(); setDeleteModalMulti(false); }}
        onCloseClick={() => setDeleteModalMulti(false)} />
      <Container fluid>
        <BreadCrumb title="Sales" pageTitle="Procurement" />
        <Row>
          <Col xxl={12}>
            <Card>
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">
                    Sales &nbsp;{isLoading && (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}> Loading... </Spinner>&nbsp;
                        <Spinner color="success" type="grow" size={"sm"}> Loading... </Spinner>&nbsp;
                      </>
                    )}
                  </h5>
                  <div className="flex-shrink-0">
                    <button type="button" className="btn btn-primary add-btn me-2" id="create-btn" onClick={() => {
                      setSale("");
                      setIsEdit(false);
                      setSubTotal(0);
                      setShip(0);
                      setTax(0);
                      setDis(0);
                      let fc = [];
                      fc.push({
                        detailId: null,
                        itemId: null,
                        item: {},
                        amount: 0,
                        quantity: 0,
                        total: 0,
                        sku: null,
                        barcode: null,
                        brandId: null,
                      });
                      setSaleDetailItem(fc);
                      toggle();
                    }}>
                      <i className="ri-archive-line me-1 align-bottom fs-14"></i> Tambah
                    </button>  <button type="button" className="btn btn-success me-1" onClick={() => setIsExportCSV(true)}>
                      <i className="ri-file-download-line me-1 align-bottom fs-14"></i>  Export
                    </button>  <button className="btn btn-soft-danger" onClick={() => setDeleteModalMulti(true)}>
                      <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i> Delete</button>
                  </div>
                </div>
              </CardHeader>
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist" >
                    <NavItem>
                      <NavLink className={classnames({ active: activeTab === "1" }, "fw-semibold")} onClick={() => { toggleTab("1", "all"); }} href="#">
                        <i className=" ri-group-line me-1 align-bottom fs-14"></i>  All Sales
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink className={classnames({ active: activeTab === "2" }, "fw-semibold")} onClick={() => { toggleTab("2", "DRAFT"); }} href="#">
                        <i className="ri-information-line me-1 align-bottom fs-14"></i>  DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink className={classnames({ active: activeTab === "3" }, "fw-semibold")} onClick={() => { toggleTab("3", "Pending"); }} href="#">
                        <i className="ri-information-line me-1 align-bottom fs-14"></i>  Pending
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink className={classnames({ active: activeTab === "4" }, "fw-semibold")} onClick={() => { toggleTab("4", "Confirmed"); }} href="#">
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i>  Confirmed    </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink className={classnames({ active: activeTab === "5" }, "fw-semibold")} onClick={() => { toggleTab("5", "Processed"); }} href="#">
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i>  Processed    </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink className={classnames({ active: activeTab === "6" }, "fw-semibold")} onClick={() => { toggleTab("6", "Completed"); }} href="#">
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i>  Completed
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={1}>
                            <div className="me-2 mb-3 col-12">
                              <select className="form-select"
                                value={pageSize} onChange={onChangeInSelect}> {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>{pageSize}</option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={4}>
                            <div className="search-box me-2 mb-3 d-inline-block col-12">
                              <input id="search-bar-0" type="text" className="form-control search"
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                placeholder={`${countSearch} Search...`} value={searchValue ?? ""} />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={6}>
                            <div className="search-box me-2 mb-3 col-12">
                              <Flatpickr className="form-control" id="datepicker-publish-input" placeholder="Select publish date"
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d"
                                }}
                                onChange={(selectedDates, dateStr) => { setFilterDate(dateStr); }} /><i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div>
                              <button type="button" className="btn btn-light w-100" onClick={() => { handleFilter(); }}>              <i className="ri-search-line me-1 align-bottom fs-14"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={previousPage} disabled={!canPreviousPage}>{"<"}</Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">Page    <strong>
                      {pageIndex + 1} of {pageOptions.length}
                    </strong>
                    </Col>
                    <Col className="col-md-auto">
                      <Input
                        type="number"
                        min={1}
                        style={{ width: 70 }}
                        max={pageOptions.length}
                        defaultValue={pageIndex + 1}
                        onChange={onChangeInInput}
                      />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>{">"}</Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>{!!isEdit ? "Edit Sale" : "Add Sale"}</ModalHeader>
                  <Form onSubmit={(e) => { e.preventDefault(); validation.handleSubmit(); return false; }}>
                    <ModalBody>
                      <CardBody className="border-bottom border-bottom-dashed p-4">
                        <Row>
                          <Col lg={5}>
                            <div className="profile-user mx-auto mb-3">
                              <Input
                                id="profile-img-file-input"
                                type="file"
                                className="profile-img-file-input" />
                              <Label for="profile-img-file-input" className="d-block">
                                <span className="overflow-hidden border border-dashed d-flex align-items-center justify-content-center rounded" style={{ height: "60px", width: "256px" }}>
                                  <img src={logoDark} className="card-logo card-logo-dark user-profile-image img-fluid" alt="logo dark" />
                                  <img src={logoLight} className="card-logo card-logo-light user-profile-image img-fluid" alt="logo light" />
                                </span>
                              </Label>
                            </div>
                            <div>
                              <div>
                                <Label for="companyAddress">Ship To</Label>
                              </div>
                              <div className="mb-3">
                                <Select name="branch" placeholder="Select Warehouse"
                                  value={validation.values.branch}
                                  onChange={(e) => { validation.setFieldValue("branch", e); }}
                                  options={branchList}></Select>
                                {validation.touched.branch && validation.errors.branch && (
                                  <small className="text-danger" type="invalid">{validation.errors.branch}</small>
                                )}
                              </div>
                              <Row className="mb-3">
                                <Col lg={7} sm={7}>
                                  <Select name="shipment_carrier" placeholder="Shipping Carrier"
                                    value={validation.values.shipment_carrier}
                                    onChange={(e) => { validation.setFieldValue("shipment_carrier", e); }}
                                    options={shipmentCarrierList}></Select>
                                  {validation.touched.shipment_carrier && validation.errors.shipment_carrier && (
                                    <small className="text-danger" type="invalid">{validation.errors.shipment_carrier}</small>
                                  )}
                                </Col>
                                <Col lg={5} sm={5}>
                                  <Select name="shipment_method" placeholder="Method"
                                    value={validation.values.shipment_method}
                                    onChange={(e) => { validation.setFieldValue("shipment_method", e); }}
                                    options={shipmentMethodList}></Select>
                                  {validation.touched.shipment_method && validation.errors.shipment_method && (
                                    <small className="text-danger" type="invalid">{validation.errors.shipment_method}</small>
                                  )}
                                </Col>
                              </Row>
                            </div>
                          </Col>
                          <Col lg={4} className="ms-auto">
                            <div className="mb-3">
                              <Select name="company"
                                value={validation.values.company}
                                placeholder="Pilih Perusahaan"
                                onChange={(e) => { validation.setFieldValue("company", e); handleCompanyClick(e.value) }}
                                options={companyList}></Select>
                              {validation.touched.company && validation.errors.company && (
                                <small className="text-danger" type="invalid">{validation.errors.company}</small>
                              )}
                            </div>
                            <div className="mb-3">
                              {departmentLoading ? (<Spinner color="primary" size="sm"> Loading... </Spinner>) : ""}
                              <Select name="department" placeholder="Select Department"
                                value={validation.values.department}
                                onChange={(e) => { validation.setFieldValue("department", e); }}
                                options={departmentList}
                                invalid={validation.touched.department && validation.errors.department ? true : false}></Select>
                              {validation.touched.department && validation.errors.department ? (
                                <small className="text-danger" type="invalid">{validation.errors.department}</small>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              {vendorLoading ? (<Spinner color="primary" size="sm"> Loading... </Spinner>) : ""}
                              <Select name="vendor"
                                value={validation.values.vendor}
                                placeholder="Select Vendor"
                                onChange={(e) => { validation.setFieldValue("vendor", e); }}
                                options={vendorList}
                                invalid={validation.touched.vendor && validation.errors.vendor ? true : false}></Select>
                              {validation.touched.vendor && validation.errors.vendor ? (
                                <small className="text-danger" type="invalid">{validation.errors.vendor}</small>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <Input name="transaction_no" id="transaction_no" className="form-control" placeholder="Enter No Transaksi" type="text"
                                value={validation.values.transaction_no}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                invalid={validation.touched.transaction_no && validation.errors.transaction_no ? true : false} />
                              {validation.touched.transaction_no && validation.errors.transaction_no && (
                                <small className="text-danger" type="invalid">{validation.errors.transaction_no}</small>
                              )}
                              <small className="text-success" type="invalid">* automatic numbering if left blank</small>
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                      <CardBody className="p-4">
                        <Row className="g-3">
                          <Col lg={3} sm={6}>
                            <div className="mb-3">
                              <label className="form-label" htmlFor="transaction_reff"> Transaction Reff </label>
                              <Input name="transaction_reff" id="transaction_reff" className="form-control" placeholder="Enter Transaction Reff" type="text"
                                value={validation.values.transaction_reff}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                invalid={validation.touched.transaction_reff && validation.errors.transaction_reff ? true : false} />
                              {validation.touched.transaction_reff && validation.errors.transaction_reff && (
                                <small className="text-danger" type="invalid">{validation.errors.transaction_reff}</small>
                              )}
                            </div>
                          </Col>
                          <Col lg={3} sm={6}>
                            <div className="mb-3">
                              <label htmlFor="datepicker-publish-input" className="form-label">Transaction Date</label>
                              <Flatpickr name="transactionat" className="form-control" placeholder="Transaction date"
                                options={{ enableTime: false, time_24hr: false, dateFormat: "Y/m/d", }}
                                value={validation.values.transactionat || ''}
                                onChange={(obj, str) => { validation.setFieldValue("transactionat", str) }} />
                              {validation.touched.transactionat && validation.errors.transactionat && (
                                <small className="text-danger" type="invalid">{validation.errors.transactionat}</small>
                              )}
                            </div>
                          </Col>
                          <Col lg={3} sm={6}>
                            <div className="mb-3">
                              <label htmlFor="datepicker-publish-input" className="form-label">Due Date</label>
                              <Flatpickr name="dueat" className="form-control" placeholder="Due date"
                                options={{ enableTime: false, time_24hr: false, dateFormat: "Y/m/d", }}
                                value={validation.values.dueat || ''}
                                onChange={(obj, str) => { validation.setFieldValue("dueat", str) }} />
                              {validation.touched.dueat && validation.errors.dueat && (
                                <small className="text-danger" type="invalid">{validation.errors.dueat}</small>
                              )}
                            </div>
                          </Col>
                          <Col lg={3} sm={6}>
                            <div>
                              <Label for="totalamountInput">Total Amount</Label>
                              <Input name="total_desc" type="text" className="form-control bg-light border-0" id="totalamountInput" placeholder="0" readOnly
                                value={currencyFormat((subTotal + (tax / 100) * (subTotal + ship - dis) + ship) - dis)} />
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                      <CardBody className="p-4 border-top border-top-dashed">
                        <div className="table-responsive">
                          <Table className="invoice-table table-borderless table-nowrap mb-0">
                            <thead className="align-middle">
                              <tr className="table-active">
                                <th scope="col" style={{ width: "20px" }}>#</th>
                                <th scope="col">Detail Produk</th>
                                <th scope="col" style={{ width: "120px" }}>Rate</th>
                                <th scope="col" style={{ width: "150px" }}>Quantity</th>
                                <th scope="col" className="text-end" style={{ width: "150px" }}>Amount</th>
                                <th scope="col" className="text-end" style={{ width: "35px" }}></th>
                              </tr>
                            </thead>
                            <tbody id="newlink">
                              {saleDetailItem.map((o, i) => {
                                return (
                                  <tr key={i} id={i} className="product">
                                    <th scope="row" className="product-id">{i + 1}</th>
                                    <td className="text-start">
                                      {saleType === "Product" && (
                                        <AsyncSelect name={`saleDetailItem.${i}.id`}
                                          value={saleDetailItem[i].item || {}}
                                          placeholder="Enter Product"
                                          onChange={(e) => {
                                            validation.setFieldValue(`saleDetailItem.${i}.id`, e);
                                            saleDetailItem[i].item = e;
                                            saleDetailItem[i].sku = e.sku;
                                            saleDetailItem[i].barcode = e.barcode;
                                            saleDetailItem[i].itemId = e.productVarianId;
                                            saleDetailItem[i].brandId = e.brandId;
                                            saleDetailItem[i].amount = Math.round(e.price, 0);
                                            handleTotalSale();
                                          }}
                                          cacheOptions
                                          loadOptions={promiseProductOptions}></AsyncSelect>
                                      )}
                                    </td>
                                    <td>
                                      <Input name={`saleDetailItem.${i}.amount`} placeholder="Price" type="text" className="form-control product-price" style={{ width: "180px" }}
                                        value={saleDetailItem[i].amount || 0}
                                        onChange={(e) => {
                                          validation.setFieldValue(`saleDetailItem.${i}.amount`, e.target.value);
                                          saleDetailItem[i].amount = e.target.value;
                                          handleTotalSale();
                                        }}
                                        onBlur={validation.handleBlur} />
                                    </td>
                                    <td>
                                      <div className="input-step">
                                        <button type="button" className="minus" onClick={() => {
                                          saleDetailItem[i].quantity = saleDetailItem[i].quantity > 0 ? saleDetailItem[i].quantity - 1 : saleDetailItem[i].quantity;
                                          validation.setFieldValue(`saleDetailItem.${i}.quantity`, saleDetailItem[i].quantity);
                                          handleTotalSale();
                                        }}>–</button>
                                        <Input name={`saleDetailItem.${i}.quantity`} placeholder="Qty" type="text" className=" product-quantity border-0" style={{ width: "80px" }}
                                          value={saleDetailItem[i].quantity || 0}
                                          onChange={(e) => {
                                            validation.setFieldValue(`saleDetailItem.${i}.quantity`, e.target.value);
                                            saleDetailItem[i].quantity = e.target.value;
                                            handleTotalSale();
                                          }}
                                          onBlur={validation.handleBlur} />
                                        <button type="button" className="plus" onClick={() => {
                                          saleDetailItem[i].quantity = saleDetailItem[i].quantity + 1
                                          validation.setFieldValue(`saleDetailItem.${i}.quantity`, saleDetailItem[i].quantity);
                                          handleTotalSale();
                                        }}>+</button>
                                      </div>
                                    </td>
                                    <td className="text-end">
                                      <div>
                                        <Input name={`saleDetailItem.${i}.total`} placeholder="Total" type="text" className="form-control product-line-price bg-light border-0" style={{ width: "180px" }}
                                          readOnly
                                          value={currencyFormat(saleDetailItem[i].amount * saleDetailItem[i].quantity)}
                                          onChange={(e) => { }}
                                          onBlur={validation.handleBlur} />
                                      </div>
                                    </td>
                                    <td className="product-removal">
                                      <Link to="#" className="text-danger btn-icon btn btn-soft-danger flex-shrink-0" onClick={() => {
                                        const data = saleDetailItem[i];
                                        onClickDeleteDetailItem(data);
                                      }}>
                                        <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                      </Link>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                            <tbody>
                              <tr id="newForm" style={{ display: "none" }}><td className="d-none" colSpan="5"><p>Tambah Form</p></td></tr>
                              <tr>
                                <td colSpan="5">
                                  <Link to="#" className="btn btn-soft-success fw-medium" id="add-item" onClick={() => { handleSaleDetailAdd(); }}>
                                    <i className="ri-add-fill me-1 align-bottom"></i>Add Item
                                  </Link>
                                </td>
                              </tr>
                              <tr className="border-top border-top-dashed mt-2">
                                <td colSpan="2">
                                  <div className="mb-3">
                                    <Select name="payment_method"
                                      value={validation.values.payment_method}
                                      placeholder="Select Payment Method"
                                      onChange={(e) => { validation.setFieldValue("payment_method", e); }}
                                      options={paymentMethodList}></Select>
                                    {validation.touched.payment_method && validation.errors.payment_method && (
                                      <small className="text-danger" type="invalid">{validation.errors.payment_method}</small>
                                    )}
                                  </div>
                                  <div className="mb-3">
                                    <Select name="payment_term"
                                      value={validation.values.payment_term}
                                      placeholder="Select Payment Term"
                                      onChange={(e) => { validation.setFieldValue("payment_term", e); }}
                                      options={paymentTermList}></Select>
                                    {validation.touched.payment_term && validation.errors.payment_term && (
                                      <small className="text-danger" type="invalid">{validation.errors.payment_term}</small>
                                    )}
                                  </div>
                                  <div className="mb-3">
                                    <Select name="account"
                                      value={validation.values.account}
                                      placeholder="Pilih Akun"
                                      onChange={(e) => { validation.setFieldValue("account", e); }}
                                      options={accountingList}></Select>
                                    {validation.touched.account && validation.errors.account && (
                                      <small className="text-danger" type="invalid">{validation.errors.account}</small>
                                    )}
                                  </div>
                                  <div className="mb-3">
                                    <Input type="textarea" className="form-control" id="description" placeholder="Isi Keterangan " name="description" rows={6}
                                      value={validation.values.description ?? ""}
                                      onBlur={validation.handleBlur}
                                      onChange={validation.handleChange}
                                      invalid={validation.touched.description && validation.errors.description ? true : false} />
                                    {validation.touched.description && validation.errors.description && (
                                      <small className="text-danger" type="invalid">{validation.errors.description}</small>
                                    )}
                                  </div>
                                  <div>
                                    <Label htmlFor="address-field" className="form-label">Purchasing Document</Label>
                                    <Dropzone onDrop={acceptedFiles => { handleAcceptedFiles(acceptedFiles); }}>
                                      {({ getRootProps, getInputProps }) => (
                                        <div className="dropzone dz-clickable" style={{ cursor: "pointer", height: "140px", }} {...getRootProps({ className: "dropzone" })}>
                                          <div className="dz-message needsclick">
                                            <div>
                                              <i className="display-4 text-muted ri-upload-cloud-2-fill" />
                                              <input {...getInputProps()} />
                                            </div>
                                            <h5>Drop files here or click to upload.</h5>
                                          </div>
                                        </div>
                                      )}
                                    </Dropzone>
                                    <div className="list-unstyled mb-0" id="file-previews">
                                      {originalFiles.map((f, i) => {
                                        return (
                                          <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete" key={i + "-file"}>
                                            <div className="p-2 d-flex align-items-center">
                                              <Row className="flex-grow-1">
                                                <Col className="col-auto">
                                                  {f.mimetype.includes("image") ? (
                                                    <img data-dz-thumbnail="" height="80" className="avatar-sm rounded bg-light" alt={f.filename} src={process.env.REACT_APP_API_URL + "/files/" + f.path} />
                                                  ) : (<i className="display-6 text-muted ri-function-line" />)}
                                                </Col>
                                                <Col className="overflow-scroll">
                                                  <Link to="#" className="text-muted font-weight-bold" > {f.originalname} </Link>
                                                  <p className="mb-0"><strong>{formatBytes(f.size)}</strong></p>
                                                </Col>
                                              </Row>
                                              <Link to="#" className="text-danger btn-icon btn btn-sm btn-soft-danger flex-shrink-0" onClick={() => { handleDeleteFiles(f.id) }}>
                                                <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                              </Link>
                                            </div>
                                          </Card>
                                        );
                                      })}
                                      {selectedFiles.map((f, i) => {
                                        return (
                                          <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete" key={i + "-file"}>
                                            <div className="p-2 d-flex align-items-center">
                                              <Row className="flex-grow-1">
                                                <Col className="col-auto">
                                                  <img data-dz-thumbnail="" height="80" className="avatar-sm rounded bg-light" alt={f.name} src={f.preview} />
                                                </Col>
                                                <Col>
                                                  <Link to="#" className="text-muted font-weight-bold"> {f.name} </Link>
                                                  <p className="mb-0"><strong>{f.formattedSize}</strong></p>
                                                </Col>
                                              </Row>
                                              <Link to="#" className="text-danger btn-icon btn btn-sm btn-soft-danger flex-shrink-0" onClick={() => { handleDeleteUploadedFiles(i) }}>
                                                <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                              </Link>
                                            </div>
                                          </Card>
                                        );
                                      })}
                                    </div>
                                  </div>
                                </td>
                                <td></td>
                                <td colSpan="2" className="p-0">
                                  <Table className="table-borderless table-sm table-nowrap align-middle mb-0">
                                    <tbody>
                                      <tr>
                                        <th scope="row">Sub Total</th>
                                        <td style={{ width: "150px" }}>
                                          <Input
                                            name="sub_total_desc"
                                            value={currencyFormat(subTotal)}
                                            type="text"
                                            className="form-control bg-light border-0"
                                            id="cart-subtotal"
                                            style={{ width: "180px" }}
                                            placeholder="0.00"
                                            disabled />
                                        </td>
                                      </tr>
                                      <tr>
                                        <th scope="row">Diskon</th>
                                        <td>
                                          <Input name="discount" id="discount" className="form-control" placeholder="Diskon" type="number"
                                            value={dis}
                                            onChange={(e) => {
                                              setDis(parseInt(e.target.value) || 0)
                                              validation.setFieldValue("discount", e.target.value);
                                              handleTotalSale();
                                            }}
                                            onBlur={validation.handleBlur} />
                                        </td>
                                      </tr>
                                      <tr>
                                        <th scope="row">Shipping Price</th>
                                        <td>
                                          <Input name="shipment_amount" id="shipment_amount" className="form-control" placeholder="Shipping Price" type="number"
                                            onChange={(e) => {
                                              setShip(parseInt(e.target.value) || 0)
                                              validation.setFieldValue("shipment_amount", e.target.value);
                                            }}
                                            value={ship}
                                            onBlur={validation.handleBlur} />
                                        </td>
                                      </tr>
                                      <tr>
                                        <th scope="row">
                                          <Select name="tax"
                                            value={validation.values.tax}
                                            placeholder="Select Tax"
                                            onChange={(e) => {
                                              setTax(parseInt(e.amount));
                                              validation.setFieldValue("tax", e);
                                              handleTotalSale();
                                            }}
                                            options={taxList}></Select>
                                          {validation.touched.tax && validation.errors.tax && (
                                            <small className="text-danger" type="invalid">{validation.errors.tax}</small>
                                          )}
                                        </th>
                                        <td>
                                          <Input name="tax_amount" type="text" className="form-control bg-light border-0" id="cart-tax"
                                            value={currencyFormat((tax / 100) * (subTotal + ship - dis))}
                                            style={{ width: "180px" }}
                                            placeholder="0"
                                            disabled />
                                        </td>
                                      </tr>
                                      <tr className="border-top border-top-dashed">
                                        <th scope="row">Total Amount</th>
                                        <td>
                                          <Input name="total_desc" type="text" className="form-control bg-light border-0" id="cart-total" placeholder="0"
                                            value={currencyFormat((subTotal + (tax / 100) * (subTotal + ship - dis) + ship) - dis)}
                                            style={{ width: "180px" }}
                                            readOnly />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </Table>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </CardBody>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button type="button" className="btn btn-light" onClick={() => { setModal(false); }}> Close </button>
                        <button type="submit" className="btn btn-success" disabled={loading}>
                          <span className="d-flex align-items-center">
                            {!!isEdit ? "Update" : "Add Sale"}
                            {loading ? (<Spinner size="sm" className="flex-shrink-0" role="status"> Loading... </Spinner>) : ""}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <Modal id="showModalHistory" isOpen={modalHistory} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggleHistory}>Sale Histories</ModalHeader>
                  <ModalBody>
                    <div className="profile-timeline">
                      <div></div>
                      <div className="accordion accordion-flush" id="todayExample">
                        {info && info.sales_history && info.sales_history.map((item, i) => {
                          return (
                            <div key={i} className="accordion-item border-0">
                              <div className="accordion-header">
                                <button className="accordion-button p-2 shadow-none" type="button" id="headingOne" >
                                  <div className="d-flex">
                                    <div className="flex-shrink-0">
                                      {
                                        item?.sales_history_createdby && item?.sales_history_createdby?.employee_image && item?.sales_history_createdby?.employee_image?.path ?
                                          <img src={process.env.REACT_APP_API_URL + "/files/" + item?.sales_history_createdby?.employee_image?.path} alt="" className="rounded-circle avatar-xs" />
                                          :
                                          <div className="flex-shrink-0 avatar-xs">
                                            <div className="avatar-title bg-soft-success text-success rounded-circle fs-13">
                                              {item?.sales_history_createdby?.name.charAt(0)}
                                            </div>
                                          </div>
                                      }
                                    </div>
                                    <div className="flex-grow-1 ms-3">
                                      <h6 className="fs-14 mb-1">{item?.sales_history_createdby?.name}</h6>
                                      <p className="fw-normal text-muted mb-1">Change sale status to <span className="fw-semibold text-info">{item?.sales_history_status?.name}</span> with note:</p>
                                      <p className="fw-normal mb-1">{item.notes || "-"}</p>
                                      <small className="text-muted">{moment(item.createdat, "YYYY/MM/DD HH:mm:ss").fromNow()}</small>
                                    </div>
                                  </div>
                                </button>
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    </div>
                  </ModalBody>
                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button type="button" className="btn btn-light" onClick={() => { setModalHistory(false); }}>Tutup</button>
                    </div>
                  </div>
                </Modal>
                <Modal id="showModalApprove" isOpen={modalApprove} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggleApprove}>Add Product Approve</ModalHeader>
                  <Form onSubmit={(e) => { e.preventDefault(); validationApprove.handleSubmit(); return false; }}>
                    <ModalBody>
                      <div className="mt-2 text-center">
                        <lord-icon
                          src="https://cdn.lordicon.com/puvaffet.json"
                          trigger="loop"
                          colors="primary:#f7b84b,secondary:#f06548"
                          style={{ width: "100px", height: "100px" }}></lord-icon>
                        <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                          <h4>Are you sure ?</h4>
                          <p className="text-muted mx-4 mb-0">
                            Are you sure you want to approve sale request with total <span className="fw-semibold text-primary">{currencyFormat(sale && sale.total_amount ? sale.total_amount : 0)}</span>
                          </p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="mt-3 col-lg-12">
                          <Input name="approval_note" id="approval_note-field" className="form-control" placeholder="Enter Notes If Any" rows={4} type="textarea"
                            onChange={validationApprove.handleChange}
                            onBlur={validationApprove.handleBlur} />
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button type="button" className="btn btn-light"
                          onClick={() => { setModalApprove(false); }}>Tutup</button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">Submit</span>
                            {loading ? (<Spinner size="sm" className="flex-shrink-0" role="status">Loading...</Spinner>) : ("")}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <Modal id="showModalDetail" isOpen={modalDetail} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggleDetail}>Invoice Detail</ModalHeader>
                  <ModalBody>
                    <Row id="printThis">
                      <Col lg={12}>
                        <CardHeader className="border-bottom-dashed p-4">
                          <div className="d-flex">
                            <div className="flex-grow-1">
                              <img src={logoDark} className="card-logo card-logo-dark" alt="logo dark" height="40" />
                              <img src={logoLight} className="card-logo card-logo-light" alt="logo light" height="40" />
                              <div className="mt-sm-3 mt-3">
                                <h6 className="text-uppercase fw-semibold">{info.sales_company && info.sales_company.name}</h6>
                                <p className="mb-1">{info.sales_department && info.sales_department.name}</p>
                                <p className="mb-1"><span className="text-muted">Ship To:</span> {info.sales_branch && info.sales_branch.branch_name}</p>
                                <p className="mb-1">
                                  <span>
                                    {info.sales_branch && info.sales_branch.branch_address[0] && info.sales_branch.branch_address[0].description}, &nbsp;
                                    {info.sales_branch && info.sales_branch.branch_address[0] && info.sales_branch.branch_address[0].av && info.sales_branch.branch_address[0].av.vc.city_name}
                                  </span>
                                </p>
                                <p className="mb-1">
                                  <span>
                                    {info.sales_branch && info.sales_branch.branch_address[0] && info.sales_branch.branch_address[0].av && info.sales_branch.branch_address[0].av.vp.province_name}  &nbsp;
                                    {info.sales_branch && info.sales_branch.branch_address[0] && info.sales_branch.branch_address[0].av && info.sales_branch.branch_address[0].av.zip} &nbsp;
                                  </span>
                                </p>
                              </div>
                            </div>
                            <div className="flex-shrink-0 mt-sm-0 mt-3">
                              <h6>
                                <span className="text-muted fw-normal">Invoice Reff:</span>              <span id="legal-register-no">{info.transaction_reff && info.transaction_reff}</span>
                              </h6>
                              <h6><span className="text-muted fw-normal">Vendor:</span></h6>
                              <h6 className="text-uppercase fw-semibold"><span>{info.sales_vendor && info.sales_vendor.vendor_name}</span></h6>
                              <p className="mb-1">
                                <span>
                                  {info.sales_vendor && info.sales_vendor.vendor_address[0] && info.sales_vendor.vendor_address[0].description}, &nbsp;
                                  {info.sales_vendor && info.sales_vendor.vendor_address[0] && info.sales_vendor.vendor_address[0].av && info.sales_vendor.vendor_address[0].av.vc.city_name}
                                </span>
                              </p>
                              <p className="mb-0">
                                <span>
                                  {info.sales_vendor && info.sales_vendor.vendor_address[0] && info.sales_vendor.vendor_address[0].av && info.sales_vendor.vendor_address[0].av.vp.province_name}  &nbsp;
                                  {info.sales_vendor && info.sales_vendor.vendor_address[0] && info.sales_vendor.vendor_address[0].av && info.sales_vendor.vendor_address[0].av.zip} &nbsp;
                                </span>
                              </p>
                            </div>
                          </div>
                        </CardHeader>
                        <CardBody className="p-4">
                          <Row className="g-3">
                            <Col lg={3} xs={3}>
                              <p className="text-muted mb-2 text-uppercase fw-semibold">Invoice No</p>
                              <h5 className="fs-14 mb-0">#<span id="invoice-no">{info.transaction_no}</span></h5>
                            </Col>
                            <Col lg={3} xs={3}>
                              <p className="text-muted mb-2 text-uppercase fw-semibold">Date</p>
                              <h5 className="fs-14 mb-0">
                                <span id="invoice-date">{handleValidDate(info.transactionat)}</span>
                              </h5>
                            </Col>
                            <Col lg={3} xs={3}>
                              <p className="text-muted mb-2 text-uppercase fw-semibold">Due Date</p>
                              <h5 className="fs-14 mb-0">
                                <span id="invoice-date">{handleValidDate(info.dueat)}</span>
                              </h5>
                            </Col>
                            <Col lg={3} xs={3}>
                              <p className="text-muted mb-2 text-uppercase fw-semibold">Total Amount</p>
                              <h5 className="fs-14 mb-0"><span id="total-amount">{currencyFormat((subTotal + (tax / 100) * (subTotal + ship - dis) + ship) - dis)}</span></h5>
                            </Col>
                          </Row>
                        </CardBody>
                        <CardBody className="p-4">
                          <div className="table-responsive">
                            <Table className="table-borderless text-center table-nowrap align-middle mb-0">
                              <thead>
                                <tr className="table-active">
                                  <th scope="col" style={{ width: "50px" }}>#</th>
                                  <th scope="col">Detail Produk</th>
                                  <th scope="col">Rate</th>
                                  <th scope="col">Quantity</th>
                                  <th scope="col" className="text-end"> Amount</th>
                                </tr>
                              </thead>
                              <tbody id="products-list">
                                {saleDetailItem.map((o, i) => {
                                  return (
                                    <tr key={i} id={i} className="product">
                                      <th scope="row" className="product-id">{i + 1}</th>
                                      <td className="text-start">{saleDetailItem[i].item.label}</td>
                                      <td>{saleDetailItem[i].amount}</td>
                                      <td>{saleDetailItem[i].quantity}</td>
                                      <td className="text-end">{currencyFormat(saleDetailItem[i].amount * saleDetailItem[i].quantity)}</td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </Table>
                          </div>
                          <div className="border-top border-top-dashed mt-2">
                            <Table className="table table-borderless table-nowrap align-middle mb-0 ms-auto" style={{ width: "250px" }}>
                              <tbody>
                                <tr>
                                  <td>Sub Total</td>
                                  <td className="text-end">{currencyFormat(subTotal)}</td>
                                </tr>
                                <tr>
                                  <td>Diskon</td>
                                  <td className="text-end">{currencyFormat(dis)}</td>
                                </tr>
                                <tr>
                                  <td>Biaya Kirim</td>
                                  <td className="text-end">{currencyFormat(ship)}</td>
                                </tr>
                                <tr>
                                  <td>Pajak ({tax}%)</td>
                                  <td className="text-end">{currencyFormat((tax / 100) * (subTotal + ship - dis))}</td>
                                </tr>
                                <tr className="border-top border-top-dashed fs-15">
                                  <th scope="row">Total Amount</th>
                                  <th className="text-end">{currencyFormat((subTotal + (tax / 100) * (subTotal + ship - dis) + ship) - dis)}</th>
                                </tr>
                              </tbody>
                            </Table>
                          </div>
                          <div className="mt-3">
                            <h6 className="text-muted text-uppercase fw-semibold mb-3">Payment Details:</h6>
                            <p className="text-muted mb-1">
                              Payment Method:            <span className="fw-medium" id="payment-method">{info.sales_pm && info.sales_pm.method_name}</span>
                            </p>
                            <p className="text-muted mb-1">
                              Payment Term:            <span className="fw-medium" id="card-holder-name">{info.sales_payment_term && info.sales_payment_term.name}</span>
                            </p>
                            <p className="text-muted mb-1">
                              Shipping Via:            <span className="fw-medium" id="card-number">{info.sales_shipment_method && info.sales_shipment_method.method_name} - {info.sales_shipment_carrier && info.sales_shipment_carrier.carrier_name}</span>
                            </p>
                          </div>
                          <div className="mt-4">
                            <div className="alert alert-info">
                              <p className="mb-0">
                                <span className="fw-semibold">NOTES:</span>
                                <span id="note">{info.description}</span>
                              </p>
                            </div>
                          </div>
                        </CardBody>
                      </Col>
                    </Row>
                  </ModalBody>
                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button type="button" className="btn btn-light" onClick={() => { setModalDetail(false); }}> Close </button>
                      <button type="submit" className="btn btn-info" onClick={() => { printInvoice(document.getElementById("printThis")) }}>Print Document</button>
                      {info.statusId === 2 && (<button type="submit" className="btn btn-success" onClick={() => {
                        info.statusSaleId = 3;
                        setSale(info);
                        toggleApprove();
                      }}>Confirmed Sale</button>)}
                      {info.statusId === 3 && (<button type="submit" className="btn btn-warning" onClick={() => {
                        info.statusSaleId = 4;
                        setSale(info);
                        toggleApprove();
                      }}>Processed Sale</button>)}
                    </div>
                  </div>
                </Modal>

              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container >
    </div >
  );
};

export default Sale;